import {
  Box,
  FormControl,
  FormLabel,
  Select,
  Button,
  CircularProgress,
  TextField,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { useEffect, useState } from "react";
import http from "../../utils/http";
import { errorToastMessage } from "../../utils/toast";
import { CommonDrawerStyle, DrawerHeader } from "../Common/styles/drawer";
import { InputWrapper, LabelStyle } from "../Common/styles/form";
import { ModalActionButtonStyles } from "../Common/styles/modal";
import { setFilters } from "../../Redux/reducers/aiSearchSlice";
import { ClearIcon } from "@mui/x-date-pickers";

type Props = {
  closeModal: () => void;
};

const GlobalFilterModal = ({ closeModal }: Props) => {
  const dispatch = useAppDispatch();
  const [filters, setFilterOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const sliceFilters = useAppSelector((state) => state.aiSearch.filters);
  const [filterState, setFilterState] =
    useState<Record<string, string>>(sliceFilters);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await http.get(`/platform/participants/filters`);
        const data = res.data.data;
        const filters: any[] = [];
        Object.entries(data).forEach(([key, value]: [string, any]) => {
          filters.push({
            filter: key,
            type: value.type,
            options: value.options,
          });
        });
        setFilterOptions(
          filters.filter((item) => ["select", "input"].includes(item.type))
        );
      } catch (error) {
        errorToastMessage(error as Error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleFilterChange = (filterName: string, value: string) => {
    setFilterState((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const handleClearAll = () => {
    setFilterState({});
  };

  const submit = () => {
    dispatch(setFilters(filterState));
    closeModal();
  };

  return (
    <Box sx={CommonDrawerStyle}>
      <DrawerHeader closeDrawer={closeModal} title={"Filter By"} />
      {!loading ? (
        <Box>
          <Box sx={{ overflow: "auto", pr: 0.5 }}>
            {filters.map((item, index) => {
              return (
                <FormControl key={index} sx={{ ...InputWrapper, mb: 2 }}>
                  <FormLabel
                    sx={{ ...LabelStyle, textTransform: "capitalize" }}
                  >
                    {item.filter}
                  </FormLabel>

                  {item?.type === "input" ? (
                    <TextField
                      fullWidth
                      placeholder={`Enter ${item.filter.toLowerCase()}`}
                      value={filterState[item.filter] || ""}
                      onChange={(e) =>
                        handleFilterChange(item.filter, e.target.value)
                      }
                    />
                  ) : item?.type === "select" ? (
                    <Select
                      fullWidth
                      value={filterState[item.filter] || ""}
                      onChange={(e) =>
                        handleFilterChange(item.filter, e.target.value)
                      }
                      endAdornment={
                        filterState[item.filter] && (
                          <InputAdornment
                            sx={{ marginRight: "10px" }}
                            position="end"
                          >
                            <IconButton
                              onClick={() => {
                                handleFilterChange(item.filter, "");
                              }}
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }
                    >
                      {item.options?.length ? (
                        item.options?.map((option: any) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem key={"None"} value={""} disabled>
                          No Data available
                        </MenuItem>
                      )}
                    </Select>
                  ) : (
                    <></>
                  )}
                </FormControl>
              );
            })}
          </Box>
          <Box sx={{ ...ModalActionButtonStyles, mt: 2, mb: 2 }}>
            <Button onClick={handleClearAll} variant="outlined">
              Clear All
            </Button>
            <Button onClick={closeModal} variant="outlined">
              Cancel
            </Button>
            <Button onClick={submit} variant="contained">
              Apply
            </Button>
          </Box>
        </Box>
      ) : (
        <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default GlobalFilterModal;
